import { Factory } from '../Factory';
import { Service } from '../Service';
import { IConfigService } from '../config';
import { ResourceWrapperService } from '../utilities/ResourceWrapperService';

import IFilterService = angular.IFilterService;

export class CollectionService extends Service<any> {
  private currentCollection: Collection;

  constructor(resource: angular.resource.IResourceService, rootScope: IRootScope, filter: IFilterService, configService: IConfigService, private preferenceService: PreferenceService, resourceWrapperService: ResourceWrapperService) {
    super({resource, rootScope, filter, resourceWrapperService});

    let collectionResource = this.resource(`${configService.getServerBaseUrlForResource()}/project/:projectId/collection/:id`,
      {id: "@id", projectId: "@projectId"},
      {
        update: {method: "PUT"}
      }
    );

    this.itemResource = this.resourceWrapperService.WrapActions(collectionResource);

    this.rootScope.$on("clearCurrentSelected", () => {
      this.ClearCurrentCollection();
      if (this.items) {
        this.items.length = 0;
      }
    });


    // ProcessingEnd / CollectionUpdate are handled in React
    // (src/hooks/useCollections -> WebSocketBridge). The Angular collection detail page
    // keeps its own scope-level listeners for the same events.
  }


  public SetCurrentCollection(collection: Collection) {
    this.currentCollection = collection;
    this.rootScope.$broadcast("CollectionService.CurrentCollectionChanged", this.currentCollection);
  }

  public ClearCurrentCollection() {
    this.currentCollection = null;
    this.rootScope.$broadcast("CollectionService.CurrentCollectionChanged", this.currentCollection);
  }

  public GetCurrentCollection() {
    return this.currentCollection;
  }

    public CacheCollections(collections: ICollection[]) {
      this.items = collections.map(c => this.AsResource(c));
    }

    protected FindMethodCustomProcessing(item: any) {
      if (this.preferenceService.IsCollectionSelected(item)) {
        item.checked = true;
      }
    }
  }

frontendApp.factory("CollectionService", ["$resource", "$rootScope", "$filter", "ConfigService", "PreferenceService", "ResourceWrapperService", Factory.Create(CollectionService)]);
